import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

// Create an Axios instance
const axiosInstance = axios.create({
    baseURL: backendUrl, // Your backend base URL
});

// Add a request interceptor to include the token in all requests
axiosInstance.interceptors.request.use(config => {
    const token = localStorage.getItem('token'); // Retrieve token from localStorage
   // console.log("token: ", token);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`; // Attach token to Authorization header
    }
    return config;
}, error => {
    // Handle request error
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      console.log("⚠ Session expired (403). Logging out...");
        
        alert("⚠ Session expired (403). Logging out...");

        localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("cart"); // clear user + token

      window.location.href = "/login"; // redirect to login
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
